import { render, staticRenderFns } from "./ButtonsPanel.vue?vue&type=template&id=4673cc9c&scoped=true"
import script from "./ButtonsPanel.vue?vue&type=script&lang=js"
export * from "./ButtonsPanel.vue?vue&type=script&lang=js"
import style0 from "./ButtonsPanel.vue?vue&type=style&index=0&id=4673cc9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4673cc9c",
  null
  
)

export default component.exports